// api/refundApi.js - İade işlemleri API istekleri
import axios from 'axios';
import apiClient from './apiClient';

// Apiclent'dan API URL'ini al
const API_URL = '/api';

// Axios instance oluştur
const refundApi = axios.create({
  baseURL: `${API_URL}/refunds`,
  headers: {
    'Content-Type': 'application/json'
  }
});

// İstek interceptor'ü - her istekte token ekle
refundApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Yanıt interceptor'ü - hata işleme
refundApi.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const message = 
      error.response?.data?.message || 
      error.message || 
      'Bir hata oluştu';
    
    return Promise.reject(new Error(message));
  }
);

// Tüm iadeleri getir
export const getRefunds = async () => {
  try {
    const response = await refundApi.get('/');
    console.log('Refunds API Response:', response);
    
    // İlk kayıt varsa dekont alanlarını kontrol et
    if (response && response.length > 0) {
      console.log('İlk kayıt dekont alanları:');
      console.log('receipt_path:', response[0].receipt_path);
      console.log('receipt_image_path:', response[0].receipt_image_path);
      console.log('receipt_image:', response[0].receipt_image);
      console.log('image_path:', response[0].image_path);
      console.log('receipt:', response[0].receipt);
    }
    
    return response; // Interceptor zaten data kısmını döndürüyor
  } catch (error) {
    console.error('getRefunds hata:', error);
    throw error;
  }
};

// Belirli bir iadeyi getir
export const getRefundById = async (id) => {
  try {
    const response = await refundApi.get(`/${id}`);
    
    // Yanıtı ayrıntılı olarak kontrol et
    console.log('API Response:', response);
    
    // Dekont imajı alanlarını kontrol et ve konsola yaz
    if (response) {
      console.log('Dekont alanları kontrol:');
      console.log('receipt_path:', response.receipt_path);
      console.log('receipt_image_path:', response.receipt_image_path);
      console.log('receipt_image:', response.receipt_image);
      console.log('image_path:', response.image_path);
      console.log('receipt:', response.receipt);
    }
    
    return response; // Interceptor zaten data kısmını döndürüyor
  } catch (error) {
    console.error('getRefundById hata:', error);
    throw error;
  }
};

// Yeni iade oluştur
export const createRefund = async (refundData) => {
  // FormData kullan (dosya yükleme için)
  const formData = new FormData();
  
  // Dekont dosyası var mı kontrol et
  if (refundData.receipt_image && refundData.receipt_image instanceof File) {
    formData.append('receipt_image', refundData.receipt_image);
  }
  
  // Diğer verileri ekle (banveri dahil)
  Object.keys(refundData).forEach(key => {
    if (key !== 'receipt_image' || !(refundData[key] instanceof File)) {
      formData.append(key, refundData[key]);
    }
  });
  
  console.log('Form verileri gönderiliyor, banveri:', refundData.banveri);
  
  return await refundApi.post('/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

// İade durumunu güncelle
export const updateRefundStatus = async (id, status_id) => {
  return await refundApi.put(`/${id}/status`, { status_id });
};

// Mail durumunu güncelle
export const updateRefundMailStatus = async (id, mailSent) => {
  return await refundApi.put(`/${id}/mail-status`, { mail_sent: mailSent });
};

// Banveri (IBAN) bilgisini güncelle
export const updateBanveri = async (id, banveri) => {
  console.log(`IBAN güncelleniyor: ID=${id}, IBAN=${banveri}`);
  return await refundApi.put(`/${id}/banveri`, { banveri });
};

// İade bilgilerini güncelle
export const updateRefund = async (id, refundData) => {
  // FormData kullan (dosya yükleme için)
  const formData = new FormData();
  
  // Dekont dosyası var mı kontrol et
  if (refundData.receipt_image && refundData.receipt_image instanceof File) {
    formData.append('receipt_image', refundData.receipt_image);
  }
  
  // Diğer verileri ekle
  Object.keys(refundData).forEach(key => {
    if (key !== 'receipt_image' || typeof refundData[key] === 'string') {
      formData.append(key, refundData[key]);
    }
  });
  
  return await refundApi.put(`/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

// İade sil
export const deleteRefund = async (id) => {
  return await refundApi.delete(`/${id}`);
};

// Dekont dosyası yükle
export const uploadReceipt = async (file) => {
  const formData = new FormData();
  formData.append('receipt_image', file);
  
  return await refundApi.post('/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export default refundApi;